import { RedoFulfillmentLocationSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-location";
import * as z from "zod";

const ConnectedLocationSchema = z.object({
  name: z.string(),
  source: z.string(),
});

export const getLocationsForRoutingRules = {
  name: "getLocationsForRoutingRules" as const,
  input: z.object({}),
  output: z.object({
    locations: z.array(RedoFulfillmentLocationSchema),
    connectedLocations: z
      .record(z.string(), z.array(ConnectedLocationSchema))
      .optional(),
  }),
};
